import { IonContent, useIonViewWillLeave, IonButtons, IonButton, IonSearchbar, IonModal, IonFab, IonFabButton, IonFabList, IonLabel, IonInput, IonItemOption, IonItemOptions, IonItemSliding, IonBackButton, IonList, IonItem, IonHeader, IonPage, IonTitle, IonToolbar, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonIcon, useIonViewWillEnter, IonImg, IonSpinner } from '@ionic/react';
import { add, searchOutline, barcodeOutline, closeOutline } from 'ionicons/icons';
import './offer.css';
import { people } from 'ionicons/icons'
import axios from "axios";
import getApi from '../api';
import EnvironmentBadge from '../components/EnvironmentBadge';
import { useParams } from 'react-router';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useIonViewDidEnter } from '@ionic/react';
import { useLocalStorage } from '../components/useLocalStorage';
import { useScannerBridge } from '../hooks/useScannerBridge';
import { useIonRouter, useIonAlert } from "@ionic/react";
import { DataGrid, GridActionsCellItem, GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';

interface Picture {
  path: string;
}

interface ArtInfo {
  id: string;
  name: string;
  accounting_connector: string;
  quantity: string;
  pictures: Picture[];
}

const Offer: React.FC = () => {

  const { id } = useParams<{ id: string }>();
  const modal = useRef<HTMLIonModalElement>(null);
  const [showModal, setShowModal] = useState(false);
  let [OfferResult, setOfferResult] = useLocalStorage("offer", "");
  let [products, setProducts] = useState([]);
  const router = useIonRouter();
  const [presentAlert] = useIonAlert();
  let [artinfo, setartinfo] = useState<ArtInfo | null>(null);
  let [qty, setqty] = useState("");
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [scannerActive, setScannerActive] = useState(false);
  const [scannerLoading, setScannerLoading] = useState(false);

  const api = getApi();

  function updateArticle(name: any, accounting_connector: any, quantity: any) {
    addArticle(name, accounting_connector, quantity)
    setqty("")
    setartinfo(null)
    setShowInfoModal(false);
  }

  useIonViewWillEnter(() => {
    setOfferResult("")
  });

  useIonViewDidEnter(() => {
    api.get("/fortnox/offers/"+id+"/")
      .then(res => {
        console.log(res.data)
        setOfferResult(res.data.Offer)
      })

      api.get("/api/bbe/articles/")
      .then(res => {
        console.log(res.data)
        setProducts(res.data.results)
      })

  });

  const handleChange = (ev: Event) => {
    let query = "";
    const target = ev.target as HTMLIonSearchbarElement;
    if (target) query = target.value!.toLowerCase();

      api.get("/api/bbe/articles/?search="+query)
        .then(res => {
          console.log(res.data.Customers)
          setProducts(res.data.results)
        })

    console.log(query);
  }

  function addArticle(name: any, accounting_connector: any, quantity?: number) {

    let existingArticle = OfferResult.OfferRows.find((row: any) => row.ArticleNumber === accounting_connector);

    if (existingArticle) {
      // If quantity is 0 remove the article
      if (Number(quantity) === 0) {
        Delete(accounting_connector);
        return;
      }
      if (quantity) {
        existingArticle.Quantity = quantity;
      } else {
        existingArticle.Quantity += 1;
      }
    } else {
        let art = {
            Description: name,
            ArticleNumber: accounting_connector,
            Quantity: 1.00,
        }
        let newOfferResult = {...OfferResult};
        newOfferResult.OfferRows = [...newOfferResult.OfferRows, art];
        setOfferResult(newOfferResult);
    }

    setShowModal(false);
    setShowInfoModal(false);
}


function save(){
  delete OfferResult.BasisTaxReduction;
  delete OfferResult.TotalToPay;
  delete OfferResult.TaxReduction;
  delete OfferResult.ContributionValue;
  delete OfferResult.Gross;

  let newOfferRows = OfferResult.OfferRows.map((row: any) => {
    if (row.RowId && String(row.RowId).startsWith('B')) {
        let newRow = {...row};
        delete newRow.RowId;
        return newRow;
    } else {
        return row;
    }
});

let newOfferResult = {...OfferResult, OfferRows: newOfferRows};


  let data = {"Offer": newOfferResult}
  console.log(data)



  api.post('/fortnox/offer/update/', {
    id: OfferResult.DocumentNumber,
    data: JSON.stringify(data)
  })
  .then(function (response) {
    console.log(response);
    api.get("/fortnox/offers/"+id+"/")
    .then(res => {
      console.log(res.data)
      presentAlert({
        message: "Offerten sparades",
        buttons: ['OK'],
      })
    })
  })
  .catch(function (error) {
    console.log(error.response.data.ErrorInformation);

    if(error.response.data.ErrorInformation.message){
    presentAlert({
      message: error.response.data.ErrorInformation.message,
      buttons: ['OK'],
    })
  }
  else {
    presentAlert({
      message: 'Det gick inte att spara offerten!',
      buttons: ['OK'],
    })
  }
  });
}

  const handleScan = useCallback((code: string) => {
    if (!code || scannerLoading) return;
    
    // Close modal but keep camera running for next scan
    setScannerActive(false);
    setScannerLoading(false);
    
    const trimmed = code.trim();
    console.log('Scanned code:', trimmed);
    
    api.get("/api/bbe/articles/?accounting_connector=" + trimmed)
      .then(res => {
        console.log(res.data);
        if (res.data.count == 1) {
          addArticle(res.data.results[0].name, res.data.results[0].accounting_connector);
        } else {
          presentAlert({
            message: 'Det finns ingen artikel med det artikelnumret!',
            buttons: ['OK'],
          });
        }
      })
      .catch(err => {
        console.error('Failed to fetch article:', err);
        presentAlert({
          message: 'Kunde inte hämta artikelinformation',
          buttons: ['OK'],
        });
      });
  }, [scannerLoading, api, presentAlert]);

  const { startScanner, stopScanner } = useScannerBridge({ autoStart: false, onScan: handleScan });

  const startScan = async () => {
    if (scannerLoading || scannerActive) return;
    
    // Show modal immediately for instant feedback
    setScannerActive(true);
    setScannerLoading(true);
    
    // Start scanner in background
    try {
      await startScanner();
      setScannerLoading(false);
    } catch (error) {
      console.error('Failed to start scanner:', error);
      setScannerActive(false);
      setScannerLoading(false);
      presentAlert({
        header: 'Fel',
        message: 'Kunde inte starta skannern. Kontrollera behörigheter.',
        buttons: ['OK']
      });
    }
  };

  const handleStopScanner = () => {
    stopScanner();
    setScannerActive(false);
    setScannerLoading(false);
  };

  useIonViewWillLeave(() => {
    if (scannerActive) {
      stopScanner();
      setScannerActive(false);
    }
  });


  const [barcodeRead, setBarcodeRead] = useState("");
  
      if (barcodeRead.length > 0) {
  
        api.get("/api/bbe/articles/?accounting_connector="+barcodeRead)
        .then(res => {
          console.log(res.data)
          if(res.data.count == 1){
            addArticle(res.data.results[0].name, res.data.results[0].accounting_connector)
          } else {
            presentAlert({
              message: 'Det finns ingen artikel med artikelnumret: '+barcodeRead,
              buttons: ['OK'],
            })
          }
        })
  
        setBarcodeRead(""); 
  
      }
    
      const barcode = {
        timing: 1000,
        data: "",
      };
    
      const barcodeReaded = () => {
        if (barcode.data.length > 5) {
          setBarcodeRead(barcode.data);
  
        } else {
          barcode.data = "";
        }
      };
    
      let timeout = setTimeout(barcodeReaded, 500);
    
      useEffect(() => {
        window.addEventListener("keypress", (e) => {
          console.log(e.key);
          console.log(e.timeStamp);
          if (barcode.data.length === 0 || e.timeStamp - barcode.timing < 200) {
            if (e.key === "Enter") {
              barcodeReaded();
              barcode.data = ""; // Reset barcode data
              barcode.timing = 1000; // Reset barcode timing
              return
            } else {
            barcode.data += e.key;
            barcode.timing = e.timeStamp;
            clearTimeout(timeout);
            timeout = setTimeout(barcodeReaded, 500);
            }
          } else {
            barcode.data = "";
          }
          console.log(barcode);
        });
      }, []);


function articleinfo(art: any, qty: any) {
  setqty(qty)
  api.get("/api/bbe/articles/?accounting_connector="+art)
      .then(res => {
        console.log(res.data)
        if(res.data.count == 1){
          setartinfo(res.data.results[0])
        } else {
          presentAlert({
            message: 'Fel vid inläsningen av artikeln!',
            buttons: ['OK'],
          })
        }
      })
    setShowInfoModal(true);

    }


    function Delete(id: any) {
      console.log("Delete")
    
      setOfferResult((prev:any) => {
        const items = OfferResult.OfferRows.filter((art: any) => art.ArticleNumber !== id)
        const newState = prev;
        OfferResult.OfferRows = items;
        setShowInfoModal(false);
        return { ...newState };
      });
    }

  return (
    <IonPage placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonButtons slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            {scannerActive ? (
              <IonButton onClick={handleStopScanner} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonIcon icon={closeOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
              </IonButton>
            ) : (
              <IonBackButton />
            )}
          </IonButtons>
          <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            {scannerActive ? 'Skanna streckkod' : `Offert: ${OfferResult.DocumentNumber}`}
          </IonTitle>
          <div slot="end" style={{paddingRight:'8px'}}><EnvironmentBadge /></div>
        </IonToolbar>
      </IonHeader>
      <IonContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <div className="top">
        <IonCard class="card" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Orgsnummer:</IonCol>
                  <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> { OfferResult.OrganisationNumber } </IonCol>
                </IonRow>
              </IonItem>
              <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Kontaktperson:</IonCol>
                  <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> { OfferResult.YourReference } </IonCol>
                </IonRow>
              </IonItem>
            </IonList>
            <IonButton size="large" color="success" onClick={() => save()} expand="block" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Spara</IonButton>
          </IonCardContent>
        </IonCard>
        </div>
        <div id="reader" className="camera"></div>
        <div id="data-capture-view"></div>
        
        <IonCard class="card" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonCardContent placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonRow className='row header' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonCol size="3" className='col' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Art.nr</IonCol>
              <IonCol size="2" className='col' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Antal</IonCol>
              <IonCol className='col' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Namn</IonCol>
          </IonRow>
            { OfferResult.OfferRows?.map((art: any) => (
                    <IonRow onClick={() => articleinfo(art['ArticleNumber'], art['Quantity'])} className='row' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonCol size="3" className='col' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{ art['ArticleNumber'] }</IonCol>
                      <IonCol size="2" className='col' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{ art['Quantity'] }</IonCol>
                      <IonCol className='col' placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>{ art['Description'] }</IonCol>
                  </IonRow>
                  ))}
            </IonCardContent>
          </IonCard>


        <IonFab slot="fixed" vertical="bottom" horizontal="end" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonFabButton onClick={() => setShowModal(false)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonIcon icon={add} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
          </IonFabButton>
          <IonFabList side="top" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonFabButton onClick={() => setShowModal(true)} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon icon={searchOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
            </IonFabButton>
            <IonFabButton onClick={() => startScan()} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <IonIcon icon={barcodeOutline} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonIcon>
            </IonFabButton>
          </IonFabList>
        </IonFab>

        <IonModal isOpen={showModal} ref={modal} trigger="open-modal" initialBreakpoint={1} breakpoints={[0, 1]} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <IonContent className="ion-padding" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonSearchbar placeholder="Sök" debounce={500} onIonChange={(ev) => handleChange(ev)} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}></IonSearchbar>
            <IonList class="list" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              
              { products.map((result: any) => (
                <IonItem onClick={() => addArticle(result["name"], result["accounting_connector"])} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  <h2> { result["name"] } </h2>
                  <p>{ result["sale_price"] }</p>
                </IonLabel>
              </IonItem>
              ))}
            </IonList>
          </IonContent>
        </IonModal>

        <IonModal isOpen={showInfoModal} trigger="open-modal" initialBreakpoint={1} breakpoints={[1]} backdropDismiss={true} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          <IonContent className="ion-padding" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                          
                          <IonGrid placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonCol size="12" size-sm="6" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                  <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                    <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Artikelnummer:</IonCol>
                                    <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> {artinfo?.accounting_connector} </IonCol>
                                  </IonRow>
                                </IonItem>
                                
                                <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                  <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                    <IonCol size="3" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Namn:</IonCol>
                                    <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> {artinfo?.name} </IonCol>
                                  </IonRow>
                                </IonItem>
                
                                <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                  <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                    <IonCol size="auto" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>I lager:</IonCol>
                                    <IonCol size="auto" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> <span>{Number(artinfo?.quantity)} </span></IonCol>
                                  </IonRow>
                                </IonItem>
                
                                <IonItem placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                                <IonCol size="5" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Antal:</IonCol>
                                <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}> <IonInput type="number" onIonChange={(e) => setqty(e.detail.value!)} value={qty} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} placeholder={undefined}></IonInput></IonCol>
                                </IonItem>
                                <IonImg
                                    src={artinfo?.pictures[0]?.path || "https://butik.bbe.nu/assets/images/no-product-image.jpg"}
                                    alt="Ingen bild :)" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} ></IonImg>
                              </IonList>
                              </IonCol>
                            </IonRow>
                            <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                            <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonButton onClick={() => Delete(artinfo?.accounting_connector)} size="large" color="danger"  expand="block" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Ta bort artikel</IonButton></IonCol>
                            </IonRow>
                            <IonRow placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                              <IonCol placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}><IonButton onClick={() => updateArticle(artinfo?.name, artinfo?.accounting_connector, qty)} size="large" color="success"  expand="block" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Spara</IonButton></IonCol>
                            </IonRow>
                          </IonGrid>
                            
                          </IonContent>
                        </IonModal>

      </IonContent>

      {/* Scanner overlay - visas bara när skanner är aktiv */}
      <div 
        id="data-capture-view" 
        style={{ position: 'fixed', inset: 0, zIndex: 20, pointerEvents: 'none', display: scannerActive ? 'block' : 'none' }} 
      />
      
      {/* Loading overlay när skannern startar */}
      {scannerActive && scannerLoading && (
        <div style={{
          position: 'fixed',
          inset: 0,
          zIndex: 21,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          pointerEvents: 'none'
        }}>
          <div style={{ textAlign: 'center', color: 'white' }}>
            <IonSpinner name="crescent" style={{ width: '48px', height: '48px' }} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
            <div style={{ marginTop: '16px', fontSize: '16px' }}>Startar kamera...</div>
          </div>
        </div>
      )}

    </IonPage>
  );
};

export default Offer;

